angular.module('CarsSaraBo').controller('PickupPointsController', ['$scope', '$routeParams', '$location', 'PickupPointService', 'PickupPointServiceAll','$filter', 'GAService', 'SessionService',
                                          function($scope, $routeParams,$location, pickupPointService, pickupPointServiceAll,$filter, gaService, sessionService) {
	
	$scope.initialize = function() {
		$scope.pickupPoints= [];
		$scope.showProgressBar();
		$scope.validations={};
		$scope.config = {
				itemsPerPage:10,
				currentPage:1,
				numPages:0,
				totalItems:0
			}
		$scope.pagePickUpPointsList = [];
		pickupPointService.query({companyOid: $routeParams.companyOid, fields:"oid,surcharge,name,pointOfSaleName" }, function(pickupPoints) {
			$scope.hideProgressBar();
			$scope.validations.pickupPoints=true;
			$scope.pickupPoints = pickupPoints;
			$scope.config.totalItems = $scope.pickupPoints.length;
			$scope.config.numPages=Math.floor($scope.pickupPoints.length/$scope.config.itemsPerPage);
			$scope.changePage();
		});
		$scope.editablePickUpPoint = $scope.loggedUserAllowed('PERM_PICKUP_POINT_CREATE') ||  $scope.loggedUserAllowed('PERM_PICKUP_POINT_EDIT') ||  $scope.loggedUserAllowed('PERM_PICKUP_POINT_DELETE');
		$scope.order = {field : "" , desc : false};
		$scope.currencyCode = sessionService.session.currencyCode;
	}
	
	$scope.changePage = function(){
		var startItem = $scope.config.itemsPerPage*$scope.config.currentPage;
		$scope.pagePickUpPointsList = $scope.pickupPoints.slice(startItem-$scope.config.itemsPerPage, startItem);
	}
	
	$scope.sort = function(fieldName, desc){
		if($scope.order.field != fieldName){
			$scope.order.field = fieldName;
			$scope.order.desc = desc != undefined ? desc : false;
		} else {
			$scope.order.desc = desc != undefined ? desc : !$scope.order.desc;
		}
		
		$scope.pickupPoints = $filter('orderBy')($scope.pickupPoints, $scope.order.field, $scope.order.desc);
		$scope.goToFirstPage();
	}
	
	$scope.goToFirstPage = function (){
		$scope.currentPage = 1;
		$scope.changePage();
	}
	
	$scope.edit = function(pickupPoint) {
		$location.path("/company/" +  $routeParams.companyOid + "/additionalPoint/" + pickupPoint.oid)
	}
	
	$scope.create = function() {
		$location.path("/company/" +  $routeParams.companyOid + "/additionalPoint/add")
	}
	
	$scope.itemsToRemove = function() {
		return _.filter($scope.pickupPoints, {"selected" : true});
	}
	
	$scope.remove = function() {
		var oids = []
		var toRemove = $scope.itemsToRemove();
		angular.forEach(toRemove, function(point) {oids.push(point.oid)});
		countToRemove = toRemove.length;
	
		if(countToRemove > 0) {
    		$scope.showModal("REMOVE_ALERT_TITLE", "REMOVE_ALERT_DESCRIPTION", function() {
    			pickupPointServiceAll.remove({companyOid: $routeParams.companyOid, oids: oids})
    			.$promise.then(function() {
                    gaService.notify("Autos_puntos_adicionales_retiro_devolucion", "eliminar_punto_adicional", [countToRemove]);
    			    $scope.initialize();	
    			 });
    		});
		}
	}
	
	$scope.initialize();
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/pickupPoints_controller.js
// module id = 905
// module chunks = 3